// CookieConsent library should be loaded via CDN in HTML head
// <script src="https://cdn.jsdelivr.net/gh/orestbida/cookieconsent@3.1.0/dist/cookieconsent.umd.js"></script>

CookieConsent.run({
  root: '#cookie-consent',

  guiOptions: {
    consentModal: {
      layout: 'bar bottom',
      position: 'bottom',
    },
  },

  categories: {
    necessary: {
      enabled: true,
      readOnly: true,
    },
  },

  language: {
    default: 'en',
    translations: {
      en: {
        consentModal: {
          description:
            'This website uses cookies to ensure you get the best experience on our website. <a href="#">Learn more</a>',
          acceptAllBtn: 'Got it!',
        },
      },
    },
  },
});
